import { ref } from 'vue'

export interface ConfirmOptions {
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  type?: 'danger' | 'warning'
  onConfirm?: () => void | Promise<void>
  onCancel?: () => void
}

interface ConfirmState extends ConfirmOptions {
  visible: boolean
  resolve?: (value: boolean) => void
}

const confirmState = ref<ConfirmState>({
  visible: false,
  title: '',
  message: '',
  confirmText: '确认',
  cancelText: '取消',
  type: 'warning'
})

export function useConfirm() {
  const show = (options: ConfirmOptions): Promise<boolean> => {
    return new Promise((resolve) => {
      confirmState.value = {
        ...options,
        visible: true,
        resolve
      }
    })
  }

  const confirm = async () => {
    if (confirmState.value.onConfirm) {
      await confirmState.value.onConfirm()
    }
    if (confirmState.value.resolve) {
      confirmState.value.resolve(true)
    }
    confirmState.value.visible = false
  }

  const cancel = () => {
    if (confirmState.value.onCancel) {
      confirmState.value.onCancel()
    }
    if (confirmState.value.resolve) {
      confirmState.value.resolve(false)
    }
    confirmState.value.visible = false
  }

  const hide = () => {
    confirmState.value.visible = false
  }

  return {
    confirmState,
    show,
    confirm,
    cancel,
    hide
  }
}
